import React from "react";
import icon1 from "../assets/icons/Component 1.png"
import icon2 from "../assets/icons/Component 2.png"
import icon3 from "../assets/icons/Component 3.png"
import icon4 from "../assets/icons/Component 4.png"
import icon5 from "../assets/icons/Component 5.png"
import icon6 from "../assets/icons/Component 6.png"
import icon7 from "../assets/icons/Component 7.png"
import icon8 from "../assets/icons/Component 8.png"
import icon9 from "../assets/icons/Component 9.png"
import icon10 from "../assets/icons/Component 10.png"
import icon11 from "../assets/icons/Component 11.png"

const features = [
  { title: "Manage Unlimited Game Tables", desc: "Scale your business without limits. Handle as many gaming tables as needed.", img: icon1 },
  { title: "Game Table Management", desc: "Real-time table status, reservation management, and player tracking.", img: icon2 },
  { title: "Members Management", desc: "Track member profiles, loyalty points, and playing history seamlessly.", img: icon3 },
  { title: "Food & Canteen Management", desc: "Integrated ordering system with real-time kitchen display and order tracking.", img: icon4 },
  { title: "Inventory Management", desc: "Track stock levels, automatic reordering, and waste management analytics.", img: icon5 },
  { title: "Staff & Role Permissions", desc: "Granular control over staff access with customizable role-based permissions.", img: icon6 },
  { title: "Reporting & Financial Management", desc: "Comprehensive reports for sales, expenses, profits, and business insights.", img: icon7 },
  { title: "Payment & Bill Feature", desc: "Multiple payment methods, bill splitting, and instant settlement options.", img: icon8 },
  { title: "Notifications & Alerts", desc: "Real-time alerts for low stock, customer arrivals, and system updates.", img: icon9 },
  { title: "Data Backup & Security", desc: "Enterprise-grade security with automated backups and data encryption.", img: icon10 },
  { title: "Mobile App Integration", desc: "Manage operations from anywhere with our responsive mobile application.", img: icon11 },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-slate-50 py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
            Everything You Need to Run Your Business
          </h2>
          <p className="mt-2 text-sm md:text-base text-slate-500 max-w-2xl mx-auto">
            All the tools you need integrated into one comprehensive platform
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="h-8 w-8 flex items-center justify-center text-[#7533AF]">
               <img src= {f.img} alt="" />
              </div>

              <h3 className="mt-4 font-bold text-slate-900 text-sm">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-700 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
